import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EditorialMarquee from "./components/EditorialMarquee";
import Dishes from "./components/Dishes";
import DishOfDay from "./components/DishOfDay";
import LocationSection from "./components/LocationSection";
import Footer from "./components/Footer";
import OrderPage from "./components/OrderPage";
import ReservationPage from "./components/ReservationPage";
import GalleryPage from "./components/GalleryPage";
import AdminTablesPage from "./components/AdminTablesPage";
import AdminPage from "./components/AdminPage";
import AdminBar from "./components/AdminBar";
import AdminListPage from "./components/AdminListPage";
import AdminMenuPage from "./components/AdminMenuPage";
import AdminCartePage from "./components/AdminCartePage";
import AdminPortfolioPage from "./components/AdminPortfolioPage";
import AdminSitePage from "./components/AdminSitePage";
import AdminFermeturesPage from "./components/AdminFermeturesPage";
import { useSiteContent } from "./components/siteContent";

function Landing() {
  const navigate = useNavigate();
  const site = useSiteContent();
  const mq = (txt) => {
    const arr = (txt || "")
      .split("•")
      .map((s) => s.trim())
      .filter(Boolean);
    return arr.length ? arr : undefined;
  };

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (selector) =>
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });

  const goOrder = () => navigate("/commander");
  const goReserve = () => navigate("/reserver");

  return (
    <div className="grain min-h-screen bg-[#F4F1EB] text-[#102C1F]">
      <AdminBar />
      <Navbar
        onInicio={() => scrollTo("#inicio")}
        onEncomendar={goOrder}
        onReservar={goReserve}
      />
      <main>
        <Hero
          onReservar={goReserve}
          onEncomendar={goOrder}
          onVerPratos={() => navigate("/galerie")}
        />
        <EditorialMarquee items={mq(site.marquee1)} />
        <DishOfDay onReservar={goReserve} />
        <Dishes />
        <EditorialMarquee items={mq(site.marquee2)} />
        <LocationSection />
      </main>
      <Footer onInicio={() => scrollTo("#inicio")} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/commander" element={<OrderPage />} />
        <Route path="/reserver" element={<ReservationPage />} />
        <Route path="/galerie" element={<GalleryPage />} />
        <Route path="/admin/tables" element={<AdminTablesPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/encomendas" element={<AdminListPage tipo="orders" />} />
        <Route path="/admin/reservas" element={<AdminListPage tipo="reservations" />} />
        <Route path="/admin/menu" element={<AdminMenuPage />} />
        <Route path="/admin/carte" element={<AdminCartePage />} />
        <Route path="/admin/portfolio" element={<AdminPortfolioPage />} />
        <Route path="/admin/site" element={<AdminSitePage />} />
        <Route path="/admin/fermetures" element={<AdminFermeturesPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
